/**
 * 导出请求参数
 */
export interface ExportRequest {
    /**
     * 任务 ID
     */
    task_id: string;
    /**
     * 导出格式
     */
    format: 'word' | 'pdf';
    /**
     * 语言
     */
    lang: 'zh' | 'en';
}

export const ExportApi = Symbol('ExportApi');

/**
 * 导出 API
 */
export interface ExportApi {
    /**
     * 导出分析报告
     * @returns Blob 文件流
     */
    exportReport(request: ExportRequest): Promise<Blob>;
}
